"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openKidApp = exports.downloadApp = void 0;

var env_1 = __importDefault(require("@tencent/vft-common/env"));

var openapp_1 = __importDefault(require("@tencent/vft-common/openapp"));

function downloadApp() {
  if (env_1.default.isIos || env_1.default.isMac) {
    window.location.href = 'https://itunes.apple.com/cn/app/id1108739984?mt=8';
  } else {
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.qqlivekid';
  }
}

exports.downloadApp = downloadApp;
var packageConfig = {
  iphone: {
    packageName: 'com.tencent.qqlivekid',
    packageUrl: 'qqlivekid://',
    appName: '小企鹅乐园',
    download: 'itms-apps://itunes.apple.com/cn/app/id1108739984?mt=8'
  },
  ipad: {
    packageName: 'com.tencent.qqlivekid',
    packageUrl: 'qqlivekid://v.qq.com/JumpAction?cht=1&chid=100186',
    download: 'itms-apps://itunes.apple.com/cn/app/id1108739984?mt=8'
  },
  android: {
    packageName: 'com.tencent.qqlivekid',
    packageUrl: 'qqlivekid://v.qq.com/JumpAction?cht=1&chid=100186',
    download: 'https://kid.v.qq.com/download?c=523'
  }
}; // eslint-disable-next-line

var packages = env_1.default.isAndroid ? packageConfig.android : env_1.default.isIpad ? packageConfig.ipad : packageConfig.iphone;

function openKidApp(schemaUrl) {
  return __awaiter(this, void 0, void 0, function () {
    var res, o, detectRet;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!openapp_1.default.canGetInstallState) return [3
          /*break*/
          , 7];
          if (!env_1.default.isWechat) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , openapp_1.default.launch(schemaUrl)];

        case 1:
          res = _a.sent();
          o = res.err_msg;
          detectRet = o.indexOf('launchApplication:ok') > -1 ? 1 : 0;

          if (detectRet !== 1) {
            downloadApp();
          }

          return [3
          /*break*/
          , 6];

        case 2:
          return [4
          /*yield*/
          , openapp_1.default.getInstallState(packages)];

        case 3:
          if (!_a.sent()) return [3
          /*break*/
          , 5]; // 判断是否安装APP，安装则拉起

          return [4
          /*yield*/
          , openapp_1.default.launch(schemaUrl)];

        case 4:
          // 判断是否安装APP，安装则拉起
          _a.sent();

          return [3
          /*break*/
          , 6];

        case 5:
          // 没有安装则跳转到应用宝下载地址或直接下载(腾讯新闻天天快报内)
          downloadApp();
          _a.label = 6;

        case 6:
          return [3
          /*break*/
          , 8];

        case 7:
          window.location.href = schemaUrl;
          setTimeout(function () {
            // 无安装
            downloadApp();
          }, 2000);
          _a.label = 8;

        case 8:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.openKidApp = openKidApp;
exports.default = {
  openKidApp: openKidApp,
  downloadApp: downloadApp
};